import { apiClient } from './apiClient';

export const sindicatoService = {
  getViews: async () => {
    const response = await apiClient.get('/sindicato-views');
    return response.data;
  },

  createView: async (data) => {
    const response = await apiClient.post('/sindicato-views', data);
    return response.data;
  },

  deleteView: async (id) => {
    await apiClient.delete(`/sindicato-views/${id}`);
  },

  getViewDashboard: async (id) => {
    const response = await apiClient.get(`/sindicato-views/${id}/dashboard`);
    return response.data;
  },
};
